import {Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledWeightedFreshText = styled(Typography)(({theme}) => ({
  '&.plp': {
    color: theme.palette.common.black
  },
  '&.add-to-cart': {
    color: theme.palette.grey[400]
  },
  '&.pdp': {
    fontSize: theme.spacing(1.75),
    fontWeight: theme.typography.h2.fontWeight,
    lineHeight: theme.spacing(2.64375),
    color: theme.palette.grey[400],
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.75),
      lineHeight: theme.spacing(2.8),
      display: 'flex',
      justifyContent: 'center'
    }
  },
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.spacing(1.75),
  lineHeight: theme.spacing(2.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2)
  },
  '&.phase3': {
    color: theme.palette.grey[900],
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  '&.pdp.phase3': {
    fontWeight: theme.typography.h1.fontWeight,
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(1)
  },
  '&.pdp.pdpRevamp': {
    padding: 0,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.5),
      lineHeight: theme.spacing(2)
    }
  },
  '&.searchList': {
    fontSize: theme.spacing(1.4),
    color: theme.palette.grey[400]
  },
  '&.searchListCarousel': {
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.spacing(1.5),
    color: theme.palette.grey[900]
  }
}));
